import emailjs from 'emailjs-com';

// ✅ Inicializar EmailJS con la Public Key desde .env
emailjs.init(process.env.REACT_APP_EMAILJS_USER_ID);

// ✅ Función para enviar correo de contacto
export const sendContactEmail = async (name, email, phone, subject, message, selectedApp) => {
  // 🔎 Validar datos requeridos
  if (!name || !email || !message) {
    throw new Error('Nombre, correo y mensaje son obligatorios.');
  }

  try {
    // 🚀 Enviar el correo usando EmailJS
    await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CONTACT,
      {
        from_name: name, // Nombre
        from_email: email, // Email
        telefono: phone || 'No especificado', // Teléfono
        subject: subject || 'Sin asunto', // Motivo
        selectedApp: selectedApp || 'No especificada', // Aplicación de interés
        message: message, // Mensaje
      }
    );

    console.log('Correo enviado con éxito ✅');
  } catch (error) {
    console.error('❌ Error al enviar el correo de contacto:', error);
    throw new Error(`Error al enviar el correo: ${error.message}`);
  }
};

// ✅ Función para enviar ticket de soporte
export const sendTicketEmail = async (empresa, telefono, email, aplicacion, llamarHorario, motivo, contactarCon, ticketNumber) => {
  // 🔎 Validar datos requeridos
  if (!empresa || !email || !motivo) {
    throw new Error('Empresa, email y motivo son obligatorios.');
  }

  try {
    // 🚀 Enviar el ticket usando EmailJS
    await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID_TICKET,
      {
        empresa: empresa, // Empresa
        telefono: telefono || 'No especificado', // Teléfono
        from_email: email, // Email
        aplicacion: aplicacion || 'No especificada', // Aplicación
        llamarHorario: llamarHorario || 'No especificado', // Horario para llamar
        motivo: motivo, // Motivo
        contactarCon: contactarCon || 'No especificado', // Contactar con
        ticketNumber: ticketNumber || 'No especificado', // Número de ticket
      }
    );

    console.log('Ticket enviado con éxito ✅');
  } catch (error) {
    console.error('❌ Error al enviar el ticket:', error);
    throw new Error(`Error al enviar el ticket: ${error.message}`);
  }
};

// ✅ Función para enviar el formulario de configuración (usando la segunda cuenta)
export const sendFormulario = async ({ email, respuestas }) => {
  if (!email || !respuestas) {
    throw new Error('Email y respuestas son obligatorios.');
  }

  try {
    // ✍️ Construir el cuerpo del mensaje
    const emailBody = `
      <h2>Nuevo formulario de configuración</h2>
      <p><strong>Email:</strong> ${email}</p>
      <p><strong>Respuestas:</strong></p>
      <ul>
        ${respuestas.map((respuesta, index) => `<li>${respuesta}</li>`).join('')}
      </ul>
    `;

    // 👉 Inicializar EmailJS con la segunda cuenta para el formulario
    emailjs.init(process.env.REACT_APP_EMAILJS2_USER_ID);

    // 🚀 Enviar el formulario usando la segunda cuenta de EmailJS
    await emailjs.send(
      process.env.REACT_APP_EMAILJS2_SERVICE_ID,
      process.env.REACT_APP_EMAILJS2_TEMPLATE_ID_FORM,
      {
        emailBody, // Enviamos el cuerpo completo como una variable
        from_email: email,
      }
    );

    console.log('Formulario enviado con éxito ✅');
  } catch (error) {
    console.error('❌ Error al enviar el formulario:', error);
    throw new Error(`Error al enviar el formulario: ${error.message}`);
  }
};

// ✅ Función para enviar un OTP (One-Time Password)
export const sendOTPEmail = async (email, otp) => {
  try {
    await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID_OTP,
      {
        to_email: email,
        otp: otp,
        expiration_time: "1 hora" // Información para el usuario
      }
    );
    console.log('OTP enviado con éxito ✅');
  } catch (error) {
    console.error('❌ Error al enviar el OTP:', error);
    throw new Error(`Error al enviar el OTP: ${error.message}`);
  }
};
